import { createFileRoute } from '@tanstack/react-router';
import { PartnerContactsPage } from '@/pages/partner/PartnerContactsPage';

export const Route = createFileRoute('/partner/contacts')({
  component: PartnerContactsPage
});
